'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumGlassesMinus = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.36344 0.299988C3.4623 0.299988 0.299805 3.46249 0.299805 7.36362C0.299805 11.2648 3.4623 14.4273 7.36344 14.4273C11.2646 14.4273 14.4271 11.2648 14.4271 7.36362C14.4271 3.46249 11.2646 0.299988 7.36344 0.299988ZM4.5 6.79999C4.11338 6.79999 3.8 7.11339 3.8 7.49999C3.8 7.88659 4.11338 8.19999 4.5 8.19999H10.5C10.8866 8.19999 11.2 7.88659 11.2 7.49999C11.2 7.11339 10.8866 6.79999 10.5 6.79999H4.5Z",
                    fill: "currentColor"
                }),
                jsxRuntime.jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M11.4979 11.5101L14.9999 14.998L14.0119 15.9899L10.5099 12.502L11.4979 11.5101Z",
                    fill: "currentColor"
                })
            ]
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsx("circle", {
                    cx: "7.36364",
                    cy: "7.36364",
                    r: "6.36364",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M14.0102 15L11.5001 12.5",
                    stroke: "currentColor",
                    strokeWidth: "1.4",
                    strokeLinecap: "square"
                }),
                jsxRuntime.jsx("path", {
                    d: "M10.5 7.5L4.5 7.5",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                })
            ]
        })
    });
};

module.exports = MediumGlassesMinus;
